import { jsx as _jsx } from "react/jsx-runtime";
import { ENV } from '@/configurations/env';
import { IconLogo } from '@agentguru/components';
import styles from './AppAgencyRoute.module.scss';
export function AppAgencyRoute() {
    return (_jsx("button", { type: "button", className: styles.container, onClick: function () { return window.open(ENV.APP_URL, '_blank'); }, children: _jsx(IconLogo, { variant: "agentGuruDark" }) }));
}
